import React from "react";
import Checkbox from "../common/Checkbox";
import Input from "../common/Input";
import Select from "../common/Select";

function KentuckyReferral({ data, handleChange, handleSave }) {
  return (
    <>
      <div className="row mb-4">
        <div className="col">
          <Select
            name="placementType"
            label="Placement Type"
            onChange={handleChange}
            value={data.DynamicFields.results.placementType}
            options={[
              { name: "Emergency", _id: "Emergency" },
              { name: "Initial Removal", _id: "InitialRemoval" },
              { name: "Respite Only", _id: "Respite" },
              { name: "Foster Home Disruption", _id: "FosterHomeDisruption" },
              { name: "Residential Stepdown", _id: "ResidentialStepdown" },
              { name: "Emergency Shelter", _id: "Emergency Shelter" },
              {
                name: "Relative/Kinship Disruption",
                _id: "RelativeDisruption",
              },
              {
                name: "Juvenile Detention Release",
                _id: "JuvenileDetentionRelease",
              },
              { name: "Adoption Disruption", _id: "AdoptionDisruption" },
              {
                name: "Hospital Stepdown",
                _id: "HospitalStepdown",
              },
              { name: "Failed Home Visit", _id: "FailedHomeVisit" },
              { name: "Re-entry Into Care", _id: "ReentryIntoCare" },
              { name: "Residential Disruption", _id: "ResidentialDisruption" },
            ]}
          />
        </div>
        <div className="col ms-4">
          <Select
            name="levelOfCare"
            label="Level of Care"
            onChange={handleChange}
            value={data.DynamicFields.results.levelOfCare}
            options={[
              { name: "1", _id: "1" },
              { name: "2", _id: "2" },
              { name: "3", _id: "3" },
              { name: "4", _id: "4" },
              { name: "5", _id: "5" },
              { name: "1T-Basic", _id: "1TBasic" },
              { name: "2T-Treatment", _id: "2TTreatment" },
              {
                name: "3T-Significant Treatment",
                _id: "3TSignificantTreatment",
              },
              { name: "Unknown", _id: "Unknown" },
            ]}
          />
        </div>
        <div className="col"></div>
      </div>
      <div className="ms-4">
        <Checkbox
          name="statewide"
          label="Statewide"
          onChange={handleChange}
          checked={data.DynamicFields.results.statewide === "true"}
        />
      </div>
      <div className="ms-4">
        <Checkbox
          name="multipleDivisions"
          label="Multiple Divisions"
          onChange={handleChange}
          checked={data.DynamicFields.results.multipleDivisions === "true"}
        />
      </div>
      <div className="row mb-4">
        <div className="col ms-4">
          <Checkbox
            name="siblingGroup"
            label="Sibling Group"
            onChange={handleChange}
            checked={data.DynamicFields.results.siblingGroup === "true"}
          />
        </div>
        {data.DynamicFields.results.siblingGroup === "true" && (
          <>
            <div className="col">
              <Input
                name="numberOfSiblings"
                label="Number of Siblings in Group"
                onChange={handleChange}
                value={data.DynamicFields.results.numberOfSiblings}
              />
            </div>
            <div className="col">
              <Input
                name="siblingGroupName"
                label="Sibling Group Name"
                onChange={handleChange}
                value={data.DynamicFields.results.siblingGroupName}
              />
            </div>
            <div className="col">
              <Select
                name="siblingGroupGender"
                label="Sibling Group Gender"
                onChange={handleChange}
                value={data.DynamicFields.results.siblingGroupGender}
                options={[
                  { name: "Same", _id: "Same" },
                  { name: "Mixed", _id: "Mixed" },
                ]}
              />
            </div>
          </>
        )}
      </div>
      <div className="ms-4 mb-4">
        <Checkbox
          name="teenMomBaby"
          label="Teen Mom/Baby"
          onChange={handleChange}
          checked={data.DynamicFields.results.teenMomBaby === "true"}
        />
      </div>
      <div className="ms-4 mb-4">
        <Checkbox
          name="spanishSpeaking"
          label="Spanish Speaking"
          onChange={handleChange}
          checked={data.DynamicFields.results.spanishSpeaking === "true"}
        />
      </div>
      <div className="ms-4 mb-4">
        <Checkbox
          name="medicallyFragile"
          label="Medically Fragile"
          onChange={handleChange}
          checked={data.DynamicFields.results.medicallyFragile === "true"}
        />
      </div>
      <div className="mb-4">
        <Input
          name="fosterParentIdentified"
          label="Foster Parent Identified"
          onChange={handleChange}
          value={data.DynamicFields.results.fosterParentIdentified}
        />
      </div>
      <button className="btn btn-primary ms-2" onClick={() => handleSave()}>
        Save Referral
      </button>
    </>
  );
}

export default KentuckyReferral;
